import { render, staticRenderFns } from "./TipTapHtmlViewer.vue?vue&type=template&id=42b5babe&"
import script from "./TipTapHtmlViewer.vue?vue&type=script&lang=js&"
export * from "./TipTapHtmlViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b5babe')) {
      api.createRecord('42b5babe', component.options)
    } else {
      api.reload('42b5babe', component.options)
    }
    module.hot.accept("./TipTapHtmlViewer.vue?vue&type=template&id=42b5babe&", function () {
      api.rerender('42b5babe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/TipTapHtmlViewer.vue"
export default component.exports